export default __webpack_public_path__ + "static/media/logique.3489041f.png";